
const bannerTypes = {
  inactiveUserBanner: {
    bannerType: 'warning',
    bannerTitle: 'Your username is no longer active',
    bannerMessage: 'If you feel this is an error and need further assistance, please contact producer management using chat or send an email to licensingandcontracts@amig.com. You can switch or add usernames using the dropdown above.',
    restrictUser: true
  },
  subPendingBanner: {
    bannerType: 'warning',
    bannerTitle: 'Submission pending',
    bannerMessage: 'With your signed authorization, we may review consumer reports about you. This process may take several weeks. We will then make a decision regarding appointment and/or system access. For questions, please call 1 (800) 759–9008 option 2.',
    bannerAction: { text: 'Add another username', action: () => { window.location.href = '/add-user' } },
    restrictUser: true
  },
  usernameAddedBanner: {
    bannerType: 'success',
    bannerTitle: 'Success!',
    bannerMessage: 'You have successfully added a new username.',
    bannerAction: { text: 'Add another username', action: () => { window.location.href = '/add-user' } }
  },
  success: {
    bannerType: 'success',
    bannerTitle: ''
  },
  error: {
    bannerType: 'error',
    bannerTitle: '',
    bannerMessage: ''
  }
};

const getBanner = (bannerType, toggleFunction) => {
  let banner = bannerTypes[bannerType] ? bannerTypes[bannerType] : bannerTypes['error'];
  banner.toggleBanner = toggleFunction;
  return banner;
};

const getDetailedBanner = (bannerType, title, message, subtext, actionFunction, toggleFunction, restrict = false) => {
  let banner = bannerTypes[bannerType] ? bannerTypes[bannerType] : bannerTypes['error'];
  banner.toggleBanner = toggleFunction;
  banner.bannerTitle = title;
  banner.bannerMessage = message;
  banner.bannerAction = actionFunction;
  banner.bannerSubtext = subtext;
  banner.restrictUser = restrict 
  return banner;
};

const displayBannerErrors = (err, dispatch, fetchContactProfileInfoFailure, fetchAgentPortalProfileInfoFailure, openGlobalBanner, setShowMinifiedHeader, setLegalFlowComplete, setLoadingState) => {
  dispatch(fetchContactProfileInfoFailure(err));
  dispatch(fetchAgentPortalProfileInfoFailure(err));
  openGlobalBanner(err)
  setShowMinifiedHeader(true);
  setLegalFlowComplete(true);
  dispatch(setLoadingState(false));
}

const resetGlobalBanner = (setGlobalBannerProps, setShowGlobalBanner, setShowMinifiedHeader) => {
  setGlobalBannerProps({});
  setShowGlobalBanner(false);
  setShowMinifiedHeader(false);
}

const setInactiveUserBanner = (setGlobalBannerProps, setShowGlobalBanner, setShowMinifiedHeader, location) => {
  setGlobalBannerProps(getBanner('inactiveUserBanner'));
  setShowGlobalBanner(location.pathname === '/' || location.pathname === '/federated');
  setShowMinifiedHeader(true);
}

export { getBanner, getDetailedBanner, displayBannerErrors, resetGlobalBanner, setInactiveUserBanner };
